/**
 * (c) 2015 Ignite Sales, Inc.
 * User: aholmes
 * Date: 6/23/2016
 * Time: 2:36 PM
 */
export default {
  cancel: {
    id: 'contactMe.cancel',
    description: 'Message for a cancel button for the contact form',
    defaultMessage: 'Cancel'
  },
  continue: {
    id: 'contactMe.continue',
    description: 'Message for a continue button for the contact form using appointment flow',
    defaultMessage: 'Continue'
  },
  confirmAppointment: {
    id: 'contactMe.confirmAppointment',
    description: 'Message for a confirmation button for the contact form using appointment flow',
    defaultMessage: 'Confirm Appointment'
  },
  close: {
    id: 'contactMe.close',
    description: 'Message for a close button for the contact form',
    defaultMessage: 'Close'
  },
  formDisclosure: {
    id: 'contactMe.disclosure',
    description: 'Message for form disclosures',
    defaultMessage: ''
  },
  submit: {
    id: 'contactMe.submit',
    description: 'Message for a submit button for the contact form',
    defaultMessage: 'Submit'
  },
  firstName: {
    id: 'contactMe.firstName',
    description: 'Label for first name',
    defaultMessage: 'First Name'
  },
  firstNamePlaceholder: {
    id: 'contactMe.firstName.placeholder',
    description: 'Placeholder for first name',
    defaultMessage: 'First Name'
  },
  firstNameError: {
    id: 'contactMe.firstName.error',
    description: 'Error message for invalid first name',
    defaultMessage: 'First Name is required'
  },
  lastName: {
    id: 'contactMe.lastName',
    description: 'Label for last name',
    defaultMessage: 'Last Name'
  },
  lastNamePlaceholder: {
    id: 'contactMe.lastName.placeholder',
    description: 'Placeholder for last name',
    defaultMessage: 'Last Name'
  },
  lastNameError: {
    id: 'contactMe.lastName.error',
    description: 'Error message for invalid last name',
    defaultMessage: 'Last Name is required'
  },
  businessName: {
    id: 'contactMe.businessName',
    description: 'Label for business name',
    defaultMessage: 'Business Name'
  },
  businessNamePlaceholder: {
    id: 'contactMe.businessName.placeholder',
    description: 'Placeholder for business name',
    defaultMessage: 'Business Name'
  },
  businessNameError: {
    id: 'contactMe.businessName.error',
    description: 'Error message for invalid business name',
    defaultMessage: 'Business Name is required'
  },
  email: {
    id: 'contactMe.email',
    description: 'Label for business name',
    defaultMessage: 'Email Address'
  },
  emailPlaceholder: {
    id: 'contactMe.email.placeholder',
    description: 'Placeholder for email address',
    defaultMessage: 'user@email.com'
  },
  emailError: {
    id: 'contactMe.email.error',
    description: 'Error message for invalid email address',
    defaultMessage: 'A valid email address is required'
  },
  phone: {
    id: 'contactMe.phone',
    description: 'Label for phone number',
    defaultMessage: 'Phone Number'
  },
  phonePlaceholder: {
    id: 'contactMe.phone.placeholder',
    description: 'Placeholder for phone number',
    defaultMessage: '(555) 123-4567'
  },
  phoneError: {
    id: 'contactMe.phone.error',
    description: 'Error message for invalid phone number',
    defaultMessage: 'A valid 10-digit US phone number is required.'
  },
  preferredMethodOfContact: {
    id: 'contactMe.preferredMethodOfContact',
    description: 'Label for preferred method of contact',
    defaultMessage: 'Preferred Method of Contact'
  },
  preferredMethodOfContactPlaceholder: {
    id: 'contactMe.preferredMethodOfContact.placeholder',
    description: 'Placeholder message for preferred method of contact field',
    defaultMessage: 'Please select a value'
  },
  preferredMethodOfContactError: {
    id: 'contactMe.preferredMethodOfContact.error',
    description: 'Error message for preferred method of contact field',
    defaultMessage: 'Please select a value'
  },
  preferredMethodOfContactOption1: {
    id: 'contactMe.preferredMethodOfContact.option1',
    defaultMessage: 'Email'
  },
  preferredMethodOfContactOption2: {
    id: 'contactMe.preferredMethodOfContact.option2',
    defaultMessage: 'Phone'
  },
  customerId: {
    id: 'contactMe.customerId',
    description: 'Label for customerId number',
    defaultMessage: 'Customer Id Number'
  },
  customerIdPlaceholder: {
    id: 'contactMe.customerId.placeholder',
    description: 'Placeholder for Customer Id number',
    defaultMessage: 'Customer Id'
  },
  customerIdError: {
    id: 'contactMe.customerId.error',
    description: 'Error message for invalid customerId number',
    defaultMessage: 'A valid Customer Id is required'
  },
  preferredTime: {
    id: 'contactMe.preferredTime',
    description: 'Label for preferred time',
    defaultMessage: 'Preferred Time'
  },
  preferredTimePlaceholder: {
    id: 'contactMe.preferredTime.placeholder',
    description: 'Placeholder message for preferred time field',
    defaultMessage: 'Please select a value'
  },
  preferredTimeError: {
    id: 'contactMe.preferredTime.error',
    description: 'Error message for preferred time field',
    defaultMessage: 'Please select a value'
  },
  preferredTimeOption1: {
    id: 'contactMe.preferredTime.option1',
    defaultMessage: 'Morning'
  },
  preferredTimeOption2: {
    id: 'contactMe.preferredTime.option2',
    defaultMessage: 'Afternoon'
  },
  preferredTimeOption3: {
    id: 'contactMe.preferredTime.option3',
    defaultMessage: 'Evening'
  },
  preferredTimeOption4: {
    id: 'contactMe.preferredTime.option4',
    defaultMessage: 'No Preference'
  },
  zipCode: {
    id: 'contactMe.appointmentForm.zipCode',
    description: 'Label for zip code number',
    defaultMessage: 'Zip Code'
  },
  zipCodePlaceholder: {
    id: 'contactMe.appointmentForm.zipCode.placeholder',
    description: 'Placeholder for zip code',
    defaultMessage: 'Zip Code'
  },
  zipCodeError: {
    id: 'contactMe.appointmentForm.zipCode.error',
    description: 'Error message for invalid zip code',
    defaultMessage: 'A valid zip code is required'
  },
  appointmentThanksTitle: {
    id: 'contactMe.appointmentForm.thanksTitle',
    description: 'Title for when an appointment has been completed',
    defaultMessage: 'Thank you!'
  },
  appointmentThanksText: {
    id: 'contactMe.appointmentForm.thanksText',
    description: 'Your appointment is scheduled.',
    defaultMessage: 'Your appointment is scheduled.'
  },
  appointmentCompleteText: {
    id: 'contactMe.appointmentForm.completeText',
    description: 'Text for a completed appointment',
    defaultMessage: 'We are looking forward to meeting with you and providing solutions to help grow your business.'
  },
  appointmentTimeSelectMessage: {
    id: 'contactMe.appointmentForm.timeSelectMessage',
    description: 'Instructions for selecting a time',
    defaultMessage: 'Select a time slot below and click \'Confirm\' to complete your appointment booking.'
  },
  appointmentTimeSelectError: {
    id: 'contactMe.appointmentForm.timeSelectError',
    description: 'Text for the time select form error',
    defaultMessage: 'You must select a time slot before you can continue.'
  },
  appointmentNoLocations: {
    id: 'contactMe.appointmentForm.noLocations',
    description: 'No branch locations found for the zip code entered',
    defaultMessage: 'No branch locations found for the zip code entered'
  },
  appointmentLocationFormMessage: {
    id: 'contactMe.appointmentForm.locationFormMessage',
    description: 'Text for the location form',
    defaultMessage: 'Please enter a zip code and select a location.'
  },
  appointmentLocationError: {
    id: 'contactMe.appointmentForm.locationError',
    description: 'Text for the location form error',
    defaultMessage: 'You must select a location before you can continue.'
  },
  loading: {
    id: 'contactMe.loading',
    description: 'Loading',
    defaultMessage: '...'
  },
  appointmentFailed: {
    id: 'contactMe.appointmentForm.failed',
    description: 'Failed booking message',
    defaultMessage: 'An error occurred while setting your appointment. Please try again'
  },
};
